import {ChannelOwnerLink} from './ChannelOwnerLink';
import {WorkgroupManagement} from './WorkgroupManagement';
import {useChat} from './ChatProvider';
import {managementRequest} from '../settings/ChatSettings';
import {useCallback} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import ChatWorkspace from './ChatWorkspace';

/** Route adapter only. Reuse ChatWorkspace directly outside the /chat route. */
export default function ChatPage() {
    const navigate = useNavigate();
    const {currentUser} = useChat();
    const params = useParams();
    const location = useLocation();
    const consumeDraft = useCallback(() => navigate(location.pathname, {replace: true, state: null}), [navigate, location.pathname]);
    const managing = new URLSearchParams(location.search).get('view') === 'manage';
    const conversationId = Number(params.conversation_id || 0);

    const handleConversationChange = useCallback((conversation, {source}) => {
        navigate(conversation ? `/chat/${conversation.id}` : '/chat', {replace: source === 'auto'});
    }, [navigate]);

    return (
        <ChatWorkspace
            renderHeaderActions={({conversation}) => <ChannelOwnerLink request={managementRequest} id={conversation?.id} admin={currentUser?.role === 'ADMIN'} onOpen={owner => navigate(`/chat?view=manage&create=channel&tab=${owner.kind === 'CUSTOMER' ? 'customers' : 'workers'}&owner=${encodeURIComponent(owner.owner_key)}`)} />}
            managementPane={managing ? <div className="chat-management-pane">{currentUser ? <WorkgroupManagement request={managementRequest} user={currentUser} chat /> : <p role="status">Loading…</p>}</div> : null}
            onCreateConversation={() => navigate('/chat?view=manage')}
            onOpenInbox={() => navigate('/chat?view=inbox')}
            initialInbox={new URLSearchParams(location.search).get('view') === 'inbox'}
            conversationId={conversationId}
            jobDraft={location.state?.jobDraft}
            onJobDraftConsumed={consumeDraft}
            onConversationChange={handleConversationChange}
            variant="page"
        />
    );
}
